<!--
 * @Author:
 * @Description: 监控测点配置
-->
<template>
  <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
    <el-row class="mb-10px flex">
      <el-input
        class="!w-200px mr-10px"
        size="small"
        placeholder="测点编码"
        v-model="search.kks"
        clearable
      />
      <el-input
        class="!w-200px mr-10px"
        placeholder="名称"
        size="small"
        v-model="search.dataSourceName"
        clearable
      />
      <el-select
        class="!w-200px mr-10px"
        placeholder="状态"
        v-model="search.monitorStatus"
        size="small"
        clearable
      >
        <el-option
          v-for="item in stateOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        class="!w-200px mr-10px"
        placeholder="监测测点"
        v-model="search.monitorPoint"
        size="small"
        clearable
      >
        <el-option
          v-for="item in monitorOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="searchList"> 搜索</el-button>
      <el-button size="small" @click="resetList">重置</el-button>
      <el-button type="primary" size="small" @click="batchSetMonitorPoint('batch')"
        >批量修改监控状态测点</el-button
      >
      <el-button type="primary" size="small" @click="searchList">刷新</el-button>
      <el-button type="primary" size="small" @click="goBack">返回</el-button>
    </el-row>
    <el-row class="h-full mt-10px">
      <el-table
        row-key="id"
        @selection-change="toggleSelection"
        :data="tableData"
        header-align="left"
        v-loading="tableLoading"
        height="calc(100% - 100px)"
        ref="multipleTableRef"
        stripe
        border
      >
        <el-table-column type="selection" width="55" :reserve-selection="true" />
        <el-table-column type="index" width="50" :label="`${$t('serialNumber')}`">
          <template slot-scope="scope">
            <div>
              {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="kks" label="测点编码"> </el-table-column>
        <el-table-column prop="pointName" label="测点名称"> </el-table-column>
        <el-table-column prop="pointDescription" label="测点描述"> </el-table-column>
        <el-table-column label="是否监控测点">
          <template #default="scope">
            <el-switch
              :active-value="1"
              :inactive-value="0"
              v-model="scope.row.monitorPoint"
              @change="changeStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="monitorStatus" label="状态" width="80">
          <template #default="scope">
            <span :class="scope.row.monitorStatus ? 'green' : 'red'">
              {{ scope.row.monitorStatus === 0 ? '离线' : '在线' }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="监控时间点" prop="monitorTime"></el-table-column>
      </el-table>
      <div class="flex justify-end">
        <el-pagination
          class="my-20px"
          :currentPage.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          :page-sizes="[15, 30, 50, 100]"
          :background="true"
          layout="sizes, total, prev, pager, next, jumper"
          :total="page.pageTotal"
          @size-change="searchList"
          @current-change="getTableData"
        >
        </el-pagination>
      </div>
    </el-row>
  </el-card>
</template>

<script type="text/babel">
import configManagementService from '@/services/configManagementService'

export default {
  name: '',
  data() {
    return {
      search: {
        kks: '',
        dataSourceName: '',
        monitorStatus: '',
        monitorPoint: '',
      },
      stateOptions: [
        {
          value: null,
          label: '全部',
        },
        {
          value: 1,
          label: '在线',
        },
        {
          value: 0,
          label: '掉线',
        },
      ],
      monitorStatus: '',
      // 监控状态下拉选择
      monitorOptions: [
        {
          value: null,
          label: '全部',
        },
        {
          value: 1,
          label: '监测',
        },
        {
          value: 0,
          label: '不监测',
        },
      ],
      tableData: [],
      tableLoading: false,
      multipleSelection: [],
      dataSourceConfigId: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
    }
  },
  computed: {
    queryParams() {
      return this.$route.query
    },
  },
  watch: {},
  created() {
    this.searchList()
  },
  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 搜索
    searchList() {
      this.page.pageNo = 1
      this.getTableData()
    },
    // 获取测点列表
    async getTableData() {
      this.tableLoading = true
      const res = await configManagementService.getMeasuringpointList({
        dataSourceConfigId: this.queryParams.id,
        ...this.search,
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.pageTotal = res.totalCount
      }
    },
    // 重置
    resetList() {
      this.search = this.$options.data().search
      this.$refs.multipleTableRef.clearSelection()
      this.multipleSelection = []
      this.searchList()
    },
    toggleSelection(rows) {
      this.multipleSelection = []
      if (rows) {
        this.multipleSelection = rows
      }
    },
    // 批量修改监控测点状态
    batchSetMonitorPoint(type, id) {
      if (type === 'batch' && !this.multipleSelection.length) {
        this.$message.warning('请勾选要修改的数据')
        return
      }
      this.$confirm('确认要修改所选监控测点状态吗?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let ids = []
          if (type === 'batch') {
            ids = this.multipleSelection.map((item) => {
              return item.id
            })
          } else {
            ids = [id]
          }
          const res = await configManagementService.setMonitorPoint(ids)
          if (res && res.code === 0) {
            this.$message.success('修改成功')
            this.searchList()
          }
        })
        .catch(() => {
          this.$message.warning('取消修改')
          this.searchList()
        })
    },
    // 修改监控测点状态
    async changeStatus(row) {
      this.batchSetMonitorPoint('single', row.id)
    },
  },
}
</script>
<style lang="scss" scoped>

@media (min-width: 1420px) {
  .table-container {
    height: calc(100% - 100px);
  }
}

@media (max-width: 1420px) {
  .table-container {
    height: calc(100% - 135px);
  }
}

@media (max-width: 1080px) {
  .table-container {
    height: calc(100% - 180px);
  }
}
@media (max-width: 670px) {
  .table-container {
    height: calc(100% - 225px);
  }
}
.red {
  color: red;
}
.green {
  color: green;
}

</style>
